
import { replaceAll } from '@/assets/script/utils/index.js'

export default {
  name: 'Content',
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    parsed() {
      let parsed = this.post.content
      parsed = replaceAll(parsed, /style="/g, 'data-wp-style="')
      /* parsed = replaceAll(
        parsed,
        process.env.NUXT_ENV_WORDPRESS_BASE_URL,
        process.env.NUXT_ENV_BASE_URL
      ) */
      parsed = replaceAll(parsed, 'href="#', `href="${this.post.slug}/#`)

      return parsed
    },
  },
  mounted() {
    const Flickity = require('flickity')
    const galleries = this.$refs.article.querySelectorAll(
      '.gallery, .wp-block-gallery'
    )
    Array.from(galleries).map(
      (gallery) =>
        new Flickity(gallery, {
          groupCells: true,
          prevNextButtons: true,
          cellAlign: 'left',
          adaptiveHeight: true,
          arrowShape:
            'M60 10.545 28.33 42.5H100v15H28.33L60 89.455 49.55 100 0 50 49.55 0z',
        })
    )
  },
}
